import GeolocationErrorRobot from 'assets/robots/robot-geolocation.svg';
import ServerErrorRobot from 'assets/robots/robot-server-error.svg';
import { FAILED_TO_FETCH_MEDIA_STREAM, GEOLOCATION_ERROR } from 'components/UrPlayer/urPlayerManager';
import { AccessiblePlatforms, Image } from 'frontend/types';
import NotAccessibleErrors from './NotAccessibleErrors/NotAccessibleErrors';
import TakeOverContainer from './TakeOverContainer';
import styles from './NotificationErrors.module.css';
import { Platform } from 'backend/services/types/urApiService.enums';
import { isURAccessExclusive } from 'frontend/utils/helpers';
import useSessionWithFeatureFlag from 'frontend/utils/hooks/useSessionWithFeatureFlag';
const NotificationErrors = ({
  accessiblePlatforms,
  platforms,
  image,
  programIsNotAccessible,
  displayMediaStreamError,
  displayGeolocationError
}: {
  image: Image;
  accessiblePlatforms: AccessiblePlatforms;
  platforms: Platform[];
  programIsNotAccessible: boolean;
  displayMediaStreamError?: boolean;
  displayGeolocationError: boolean;
}) => {
  const {
    data: session,
    status
  } = useSessionWithFeatureFlag();
  if (isURAccessExclusive(platforms) && status === 'loading') {
    return null;
  }
  return <>
      {programIsNotAccessible && <TakeOverContainer image={image} useImage={false}>
          <NotAccessibleErrors accessiblePlatforms={accessiblePlatforms} platforms={platforms} session={session} />
        </TakeOverContainer>}

      {displayMediaStreamError && <TakeOverContainer image={image} useImage={true}>
          <ServerErrorRobot className={styles.errorRobot} />
          <span>{FAILED_TO_FETCH_MEDIA_STREAM}</span>
        </TakeOverContainer>}

      {displayGeolocationError && <TakeOverContainer image={image} useImage={true}>
          <GeolocationErrorRobot />
          <span>{GEOLOCATION_ERROR}</span>
        </TakeOverContainer>}
    </>;
};
export default NotificationErrors;